import React from "react";
import "./DriverLogHeader.css";
import { Record, useTranslate } from "react-admin";
import TimeField from "../../../common/data-grid-fields/TimeField";
import { DriverLogDetailedView } from "../../../../common/data/service-proxies";
import { ArrayField } from "../../../common/data-grid-fields/ArrayField";
import { DriverLogHeaderHosInfo } from "./DriverLogHeaderHosInfo";
import "../../../locations/GoogleMapMarker.css";

interface Props {
  record: DriverLogDetailedView;
}

export const DriverLogHeader = ({ record }: Props) => {
  const translate = useTranslate();

  return (
    <div id="driver-log-header-wrapper">
      <div id="driver-log-header-container">
        <div className="header-row">
          <div className="driver-log-header-info">
            <strong>
              {translate("resources.hos-driver-log-view.labels.driver")}
            </strong>
            <div>{record.driverFullName}</div>
          </div>
          <div className="driver-log-header-info">
            <strong>
              {translate("resources.hos-driver-log-view.labels.cycleRule")}
            </strong>
            <div>{record.cycleRule}</div>
          </div>
        </div>
        <div className="header-row">
          <div className="driver-log-header-info">
            <strong>
              {translate("resources.hos-driver-log-view.labels.hoursWorked")}
            </strong>
            <div>
              <TimeField
                record={record as Record}
                source="minutesWorked"
                inputType="minutes"
                outputType="long"
              />
            </div>
          </div>
          <div className="driver-log-header-info">
            <strong>
              {translate("resources.hos-driver-log-view.labels.violations")}
            </strong>
            <div>
              {record.violations && record.violations.length > 0 ? (
                <ArrayField
                  record={record as Record}
                  displayedElementsCount={1}
                  source="violations"
                  displayMember="violationError"
                  labelTranslationNamespace="appData.violationTypes"
                />
              ) : (
                translate("resources.hos-driver-log-view.labels.noViolations")
              )}
            </div>
          </div>
        </div>
      </div>
      {
        <DriverLogHeaderHosInfo
          hosDetails={record.hosDetails}
          driverId={record.driverId ?? undefined}
        />
      }
    </div>
  );
};
